import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import CreatorShell from "@/components/creator/CreatorShell";
import ReplicateBanner from "@/components/myvoices/ReplicateBanner";
import VoiceHeader from "@/components/myvoices/VoiceHeader";
import TrainingSet from "@/components/myvoices/TrainingSet";
import TrainPanel from "@/components/myvoices/TrainPanel";
import VersionList from "@/components/myvoices/VersionList";
import useVoice, { useVoiceStatus } from "@/components/myvoices/useVoice";
import { safeApiError } from "@/lib/safeErrorText";

/** `/create/my-voices/:id` — training recordings, train, versions + previews for one private voice. */
export default function VoiceModelPage() {
  const { id } = useParams();
  const status = useVoiceStatus();
  const { voice, clips, versions, error, refresh } = useVoice(id);
  return (
    <CreatorShell testId="voice-model-page" back="/create/my-voices" title={voice?.name || "My Voices"} subtitle={voice?.notes || "Private singing voice"}>
      {error && !voice ? <p data-testid="voice-not-found" className="text-[14px] text-rose-200">{safeApiError(error)}</p> : null}
      {!voice && !error ? <Loader2 className="h-6 w-6 animate-spin text-white/40" /> : null}
      {voice ? (
        <div className="space-y-6 pb-20">
          <VoiceHeader voice={voice} onChanged={refresh} />
          <ReplicateBanner status={status} />
          <div className="grid gap-6 lg:grid-cols-[1.35fr_1fr]">
            <TrainingSet voice={voice} clips={clips} status={status} onChanged={refresh} />
            <TrainPanel voice={voice} clips={clips} versions={versions} status={status} onStarted={refresh} />
          </div>
          <VersionList voice={voice} versions={versions} clips={clips} connected={Boolean(status?.connected)} onChanged={refresh} />
        </div>
      ) : null}
    </CreatorShell>
  );
}
